import { LocalStorage } from '../../sharedLegacy/utils'
import { getLiveId } from '../../global/blocs/roomInfo'

const LOCAL_STORAGE_KEY = 'webinarPlaybackPositions'

export const getPlaybackPosition = (photoId) => {
  const times = LocalStorage.getJSON(LOCAL_STORAGE_KEY)
  const storedTime = times?.[getLiveId()]?.[photoId]

  if (storedTime === undefined) {
    return 0
  }

  delete times[getLiveId()][photoId]
  LocalStorage.set('webinarPlaybackPositions', times)

  return storedTime
}

export const setPlaybackPosition = (photoId, newPosition) => {
  LocalStorage.updateJSON(LOCAL_STORAGE_KEY, {
    [getLiveId()]: { [photoId]: newPosition },
  })
}
